import { render, staticRenderFns } from "./postrank.vue?vue&type=template&id=da80c732&scoped=true"
import script from "./postrank.vue?vue&type=script&lang=js"
export * from "./postrank.vue?vue&type=script&lang=js"
import style0 from "./postrank.vue?vue&type=style&index=0&id=da80c732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da80c732",
  null
  
)

export default component.exports